import { string } from 'prop-types'

import { withI18n } from 'shared/utils/withI18n'
import BorderedText from 'views/components/atoms/BorderedText'
import { PROMOTION_TYPES } from 'views/components/organisms/ProductLabels/consts'
import { i18nType } from 'views/utils/propTypes'

const ProductSpecialLabel = ({
  i18n,
  promotion,
  link,
  text,
  dataClientsideHook,
}) => {
  let href
  let labelText
  let color
  let bgColor
  let borderColor
  let noTextTransform

  switch (promotion) {
    case PROMOTION_TYPES.ONE_FOR_ONE:
    case PROMOTION_TYPES.ONE_PLUS_ONE:
      labelText = i18n._('general.label.product.oneforone')
      href = link
      color = 'positive'
      break

    case PROMOTION_TYPES.BUNDLE:
      labelText = text || i18n._('general.label.product.bundle')
      color = 'negative'
      break

    case PROMOTION_TYPES.FREEBIE:
      labelText = i18n._('general.label.product.freebie')
      href = link
      color = 'blue'
      break

    case PROMOTION_TYPES.OUT_OF_TRADE:
      labelText = i18n._('general.label.product.outOfTrade')
      href = link
      color = 'white'
      bgColor = 'red'
      borderColor = 'red'
      noTextTransform = true
      break

    default:
      return null
  }

  return (
    <BorderedText
      href={href}
      color={color}
      bgcolor={bgColor}
      bordercolor={borderColor}
      notexttransform={noTextTransform}
      dataClientsideHook={dataClientsideHook}
    >
      {labelText}
    </BorderedText>
  )
}

ProductSpecialLabel.propTypes = {
  i18n: i18nType.isRequired,
  promotion: string,
  link: string,
  text: string,
  dataClientsideHook: string,
}

ProductSpecialLabel.defaultProps = {
  promotion: null,
  link: null,
  text: null,
  dataClientsideHook: null,
}

export default withI18n()(ProductSpecialLabel)
